<script lang="ts" setup>
import { computed, reactive } from 'vue';
import { useAuthUser } from '@/helpers/globals';
import { getI18n } from '@/helpers/i18n';
import KpDropdown from '@kp/geofy-vuejs-lib/tg-system/components/KpDropdown.vue';

import KpModal from '@kp/geofy-vuejs-lib/tg-system/components/KpModal.vue';

const emit = defineEmits(['rolechange', 'cancel']);

const model = reactive({
    role: ''
});

const show = defineModel({ default: false });

defineProps<{
    loading?: boolean;
}>();

const authUser = useAuthUser();

const roles = computed(() => {
    if (!authUser || !authUser.roles) {
        return [];
    }
    const roles = [];
    for (let i = 0; i < authUser.roles.length; i++) {
        const value = authUser.roles[i];
        const text = getI18n().t('rolle_' + value);
        const gemeinden = authUser.gemeinden ? authUser.gemeinden.split(', ') : [];
        const fachstellen = authUser.fachstellen ? authUser.fachstellen.split(', ') : [];
        const buildNaziFachstellenIds = authUser.fachstellen_ids || [];
        const buildNaziGemeindenIds = authUser.gemeinden_ids || [];
        switch (value) {
            case 'fachstelle':
                for (let j = 0; j < fachstellen.length; j++) {
                    roles.push({
                        text: text + ' (' + fachstellen[j] + ')',
                        value: value + '::' + (buildNaziFachstellenIds.length > j ? buildNaziFachstellenIds[j] : '')
                    });
                }
                break;
            case 'gemeinde':
                for (let j = 0; j < gemeinden.length; j++) {
                    roles.push({
                        text: text + ' (' + gemeinden[j] + ')',
                        value: value + '::' + (buildNaziGemeindenIds.length > j ? buildNaziGemeindenIds[j] : '')
                    });
                }
                break;
            case 'admin':
                roles.push({
                    text,
                    value
                });
        }
    }

    return roles;
});

const activeRole = computed(() => {
    if (!authUser) {
        return null;
    }
    let role = authUser.active_role;
    switch (role) {
        case 'fachstelle':
            role = 'fachstelle::' + authUser.active_role_stelle_id;
            break;
        case 'gemeinde':
            role = 'gemeinde::' + authUser.active_role_stelle_id;
            break;
        default:
    }
    return role;
});

function onSetRole() {
    emit('rolechange', model.role);
}

function onUpdate(newVal: string) {
    model.role = newVal;
}
</script>
<template>
    <KpModal v-model="show">
        <h2 class="ktg-modal-title">{{ $t('rolle_auswaehlen') }}</h2>
        <form @submit.prevent="onSetRole">
            <ktg-field>
                <ktg-label for="rolle">{{ $t('rolle') }}</ktg-label>
                <KpDropdown
                    class="w-full"
                    :model-value="activeRole"
                    :options="roles"
                    display-field="text"
                    value-field="value"
                    @update:model-value="onUpdate"
                    :emit-value-cast="String"
                ></KpDropdown>
            </ktg-field>
            <div class="mt-1rem" />
            <ktg-button class="confirm-button w-full" size="small" :disabled="loading" type="submit">
                {{ $t('rolle_wechseln') }}
            </ktg-button>
            <div class="mt-0_5rem" />
            <ktg-button
                class="cancel-button w-full"
                appearance="secondary"
                size="small"
                :disabled="loading"
                @click="$emit('cancel')"
            >
                {{ $t('cancel') }}
            </ktg-button>
        </form>
    </KpModal>
</template>
